import { render, staticRenderFns } from "./VToast.vue?vue&type=template&id=5a19adce"
import script from "./VToast.vue?vue&type=script&lang=ts"
export * from "./VToast.vue?vue&type=script&lang=ts"
import style0 from "./VToast.vue?vue&type=style&index=0&id=5a19adce&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports